'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tracked = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function trackClickHOC(Component) {
  var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'UNLABELED';
  var additional = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var composed = function (_React$Component) {
    _inherits(Composed, _React$Component);

    function Composed() {
      _classCallCheck(this, Composed);

      return _possibleConstructorReturn(this, (Composed.__proto__ || Object.getPrototypeOf(Composed)).apply(this, arguments));
    }

    _createClass(Composed, [{
      key: 'handleClick',
      value: function handleClick() {
        var initialState = window.__INITIAL_STATE__ || {};
        var _initialState$userPre = initialState.userPrefs,
            userPrefs = _initialState$userPre === undefined ? {} : _initialState$userPre;


        if (typeof caLogger !== 'undefined') {
          caLogger.track(event, _extends({}, additional, {
            userUUID: userPrefs.ConcurId,
            companyUUID: userPrefs.companyUUID
          }));
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(
          'span',
          { style: this.props.style, onClick: this.handleClick },
          Component
        );
      }
    }]);

    return Composed;
  }(_react2.default.Component);
  composed.propTypes = {
    style: _propTypes2.default.object
  };
  return composed;
}

var Tracked = exports.Tracked = function (_React$Component2) {
  _inherits(Tracked, _React$Component2);

  function Tracked() {
    _classCallCheck(this, Tracked);

    return _possibleConstructorReturn(this, (Tracked.__proto__ || Object.getPrototypeOf(Tracked)).apply(this, arguments));
  }

  _createClass(Tracked, [{
    key: 'handleClick',
    value: function handleClick() {
      var initialState = window.__INITIAL_STATE__ || {};
      var _props = this.props,
          event = _props.event,
          additional = _props.additional;
      var _initialState$userPre2 = initialState.userPrefs,
          userPrefs = _initialState$userPre2 === undefined ? {} : _initialState$userPre2;


      if (typeof caLogger !== 'undefined') {
        caLogger.track(event, _extends({}, additional, {
          userUUID: userPrefs.ConcurId,
          companyUUID: userPrefs.companyUUID
        }));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        { style: this.props.style, onClick: this.handleClick.bind(this) },
        this.props.children
      );
    }
  }]);

  return Tracked;
}(_react2.default.Component);

Tracked.propTypes = {
  style: _propTypes2.default.object,
  event: _propTypes2.default.string,
  additional: _propTypes2.default.object,
  children: _propTypes2.default.node
};

exports.default = trackClickHOC;


//////////////////
// WEBPACK FOOTER
// ./lib/HOCs/trackClick.js
// module id = 35
// module chunks = 0